import MuiGrid from '../../../UI/MuiGrid/MuiGrid';

const GridProviderDelovi = ({ data = [], isLoading }) => {
  const columns = [
    // { field: 'nazivDela', headerName: 'Naziv dela', width: 200 },
    // { field: 'kolicina', headerName: 'Količina', width: 150 },
    // { field: 'nabavnaCena', headerName: 'Nabavna cena', width: 200 },
    // { field: 'cena', headerName: 'Cena', width: 200 },
    { field: 'nazivDela', headerName: 'Naziv dela', width: 300 },
    { field: 'kolicina', headerName: 'Količina', width: 80 },
    { field: 'cena', headerName: 'Cena', width: 120 },
    { field: 'nabavnaCena', headerName: 'Nabavna cena', width: 120 },

    { field: 'napomena', headerName: 'Napomena', width: 300 },
  ];

  return (
    <div style={{ height: '85vh', width: '99%' }}>
      <MuiGrid data={data} columns={columns} loading={isLoading} />
    </div>
  );
};

export default GridProviderDelovi;
